<template>
  <div class="box-inner">
    <img src="../assets/images/加载logo(1).png" alt="" />
    <ProgressBar :value="value"></ProgressBar>
    <p class="title_box-inenr">恭喜您，识别成功</p>
    <p class="new_title-box-inner">拉取防伪认证信息...</p>
  </div>
</template>
<script>
import axios from "axios";
// import { Toast } from "vant";
import ProgressBar from "../components/progressBar.vue";
export default {
    data() {
        return {
          value: 0,
            defalutSlider: [
                {
                    name: "商品信息",
                    path: "/goodsInfo?defaultId=1",
                    defaultId: 1,
                },
                {
                    name: "防伪信息",
                    path: "/securityInfo?defaultId=2",
                    defaultId: 2,
                },
                {
                    name: "企业信息",
                    path: "/enterpriseInfo?defaultId=3",
                    defaultId: 3,
                },
                {
                    name: "质检信息",
                    path: "/qsInfo?defaultId=4",
                    defaultId: 4,
                },
                {
                    name: "流通信息",
                    path: "/circulationInfo?defaultId=5",
                    defaultId: 5,
                },
                {
                    name: "智能监测",
                    path: "/intelligent?defaultId=7",
                    defaultId: 7,
                },
            ],
            params: {
                batch_code: "",
                id: "",
                merchant_id: "",
                t: "",
            },
            params_: {}
        };
    },
    async created() {
        
        try {
            this.$setApptitle("链宇宙防伪溯源");
        }
        catch {
            console.log("not webview");
        }
        // debugger
        //如果没有拿到defaultId 那么证明是直接扫码进来 此时需要拿到浏览器地址手动请求数据， 数据请求完毕后，重新带上defaultId跳转 ?id=26d326fb5ca54e08aca4acc5d0d2c085&merchant_id=88352968E3&t=1
        // const toast = Toast.loading({
        //     duration: 0,
        //     forbidClick: true,
        //     message: "查询中",
        // });
        let params = this.$route.query;
        console.log(params);
        if (params.key) {
            console.log(params.key);
             this.params_ = {
                chipData: params.key,
            };
            await axios.post('https://apigateway.klyun.com.cn/chain/brandapplets/v1.0.0/ScanTrace/GetTraceWelcomePage', {key: params.key })
             .then((res) => {
                localStorage.setItem('wel', JSON.stringify(res.data.data))
                console.log(res.data.data.scheme_url);
                if (res.data.data.scheme_url !== null) {
                    return location.href = res.data.data.scheme_url
                }
                this.getData()
             })
      }
        else {
            await axios.post('https://apigateway.klyun.com.cn/chain/brandapplets/v1.0.0/ScanTrace/GetTraceWelcomePage', {markdetailId: params.id,  merchant_id: params.merchant_id, t: params.t})
             .then((res) => {
                localStorage.setItem('wel', JSON.stringify(res.data.data))
                console.log(res.data.data.scheme_url);
                if (res.data.data.scheme_url !== null) {
                    return location.href = res.data.data.scheme_url
                }
                this.getDataK(params)
             })

        }
         
    },
    mounted() {
      let timer = setInterval(() => {
      if (this.value >= 100) {
        this.value =100;
        clearInterval(timer);
      } else {
        this.value += 0.1;
      }
    }, 2);
    },
    methods: {
        async getData() {
            await axios
                .post(
            // 正式
            // "https://apigateway.klyun.com.cn/chaintea/industry/v1.0.0/api/user/uplinksyn",
            // "https://sitapigateway.v-m.site/chaintea/industry/v1.0.0/api/user/uplinksyn",
            // "https://sitapigateway.v-m.site/chaintea/industry/v1.0.0/ScanTrace/GetScanTraceList",
            // 正式
            "https://apigateway.klyun.com.cn/chain/brandapplets/v1.0.0/ScanTrace/GetScanTraceList",
              this.params_)
                .then((res) => {
                if (res.data.code === 200) {
                          
                         // 将数据根据id用Map格式存储
                         console.log('rrrrr', res);
                            let reData = JSON.parse(res.data.data);
                            console.log(reData);
                            localStorage.setItem("reData", JSON.stringify(reData));
                            // debugger;
                            // if (!reData.data_list) {
                            //     return Toast("暂无数据");
                            // }
                            let dataObjcach = JSON.parse(res.data.data).data_list;
                            let listsTg = JSON.parse(res.data.data).lists;
                            let corporateLogoImageList = JSON.parse(res.data.data)
                                .chain_enterprise_logo_list;
                            localStorage.removeItem("lists");
                            // 将推广信息按钮配置存储在本地
                            if (listsTg) {
                                localStorage.setItem("lists", JSON.stringify(listsTg));
                            }
                            localStorage.setItem("corporateLogoImageList", JSON.stringify(corporateLogoImageList || []));
                            //遍历 将每个环节数据内容数据json字符串转为对象
                            let mapData = new Object();
                            dataObjcach.forEach((element) => {
                                mapData[element.trace_id] = element;
                                if (element.msgItems) {
                                    element.msgItems.forEach((value) => {
                                        value.op.op = JSON.parse(value.op.op);
                                    });
                                }
                            });
                            localStorage.setItem("idInObj", JSON.stringify(mapData));
                            localStorage.setItem("defalutObj", JSON.stringify(dataObjcach));
                            // 存储获取请求的id数据
                            localStorage.setItem("id", "26d326fb5ca54e08aca4acc5d0d2c085");
                            localStorage.setItem("batch_Code", "");
                            // localStorage.setItem("id", params.id);
                            // localStorage.setItem("batch_Code", params.batch_code);
                            //删除原料环节--原料环节不显示  只提供所需数据
                            let siderbarList = [];
                            let indexYL = dataObjcach.findIndex((v) => {
                                return v.trace_id == "0";
                            });
                            if (indexYL != -1) {
                                dataObjcach.splice(indexYL, 1);
                            }
                            //先进行排序
                            dataObjcach = dataObjcach.sort((a, b) => {
                                return a.sort - b.sort;
                            });
                            let slider_ContentList = [];
                            dataObjcach.forEach((element) => {
                                if (isNaN(Number(element.trace_id))) {
                                    siderbarList.push({
                                        name: element.trace_name,
                                        path: `/plantInfo`,
                                        defaultId: element.trace_id,
                                        sort: element.sort,
                                    });
                                    slider_ContentList.push(element);
                                }
                                else {
                                    //匹配默认环节
                                    let traceDefalut = this.defalutSlider.filter((v) => {
                                        return v.name == element.trace_name;
                                    });
                                    if (traceDefalut.length) {
                                        siderbarList.push({
                                            name: element.trace_name,
                                            path: traceDefalut[0].path,
                                            defaultId: traceDefalut[0].defaultId,
                                            sort: element.sort,
                                        });
                                        slider_ContentList.push(element);
                                    }
                                }
                            });
                            window.localStorage.setItem("slierBarListContent", JSON.stringify(slider_ContentList));
                            setTimeout(() => {
                                this.$router.push("/GoodsInfo");
                                // 手动清除 Toast
                                
                         }, 100);
                }
            });
        },
        async getDataK(params) {
               const { data: re } = await this.$api.getDataApi(params.id, params.batch_code, params.merchant_id, params.t);
            console.log(params);
            if (re.code === 200) {
                        console.log(re);
                        let reData = JSON.parse(re.data);
                        console.log(reData);
                        localStorage.setItem("reData", JSON.stringify(reData));
                        // debugger;
                        // if (!reData.data_list) {
                        //     return Toast("暂无数据");
                        // }
                        let dataObjcach = JSON.parse(re.data).data_list;
                        let listsTg = JSON.parse(re.data).lists;
                        let corporateLogoImageList = JSON.parse(re.data)
                            .chain_enterprise_logo_list;
                        localStorage.removeItem("lists");
                        // 将推广信息按钮配置存储在本地
                        if (listsTg) {
                            localStorage.setItem("lists", JSON.stringify(listsTg));
                        }
                        localStorage.setItem("corporateLogoImageList", JSON.stringify(corporateLogoImageList || []));
                        //遍历 将每个环节数据内容数据json字符串转为对象
                        let mapData = new Object();
                        dataObjcach.forEach((element) => {
                            mapData[element.trace_id] = element;
                            if (element.msgItems) {
                                element.msgItems.forEach((value) => {
                                    value.op.op = JSON.parse(value.op.op);
                                });
                            }
                        });
                        localStorage.setItem("idInObj", JSON.stringify(mapData));
                        localStorage.setItem("defalutObj", JSON.stringify(dataObjcach));
                        // 存储获取请求的id数据
                        localStorage.setItem("id", "26d326fb5ca54e08aca4acc5d0d2c085");
                        localStorage.setItem("batch_Code", "");
                        // localStorage.setItem("id", params.id);
                        // localStorage.setItem("batch_Code", params.batch_code);
                        //删除原料环节--原料环节不显示  只提供所需数据
                        let siderbarList = [];
                        let indexYL = dataObjcach.findIndex((v) => {
                            return v.trace_id == "0";
                        });
                        if (indexYL != -1) {
                            dataObjcach.splice(indexYL, 1);
                        }
                        //先进行排序
                        dataObjcach = dataObjcach.sort((a, b) => {
                            return a.sort - b.sort;
                        });
                        let slider_ContentList = [];
                        dataObjcach.forEach((element) => {
                            if (isNaN(Number(element.trace_id))) {
                                siderbarList.push({
                                    name: element.trace_name,
                                    path: `/plantInfo`,
                                    defaultId: element.trace_id,
                                    sort: element.sort,
                                });
                                slider_ContentList.push(element);
                            }
                            else {
                                //匹配默认环节
                                let traceDefalut = this.defalutSlider.filter((v) => {
                                    return v.name == element.trace_name;
                                });
                                if (traceDefalut.length) {
                                    siderbarList.push({
                                        name: element.trace_name,
                                        path: traceDefalut[0].path,
                                        defaultId: traceDefalut[0].defaultId,
                                        sort: element.sort,
                                    });
                                    slider_ContentList.push(element);
                                }
                            }
                        });
                        window.localStorage.setItem("slierBarListContent", JSON.stringify(slider_ContentList));
                        setTimeout(() => {
                            this.$router.push("/GoodsInfo");
                            // 手动清除 Toast
                            // Toast.clear();
                        }, 100);
            }
        }
    },
    components: { ProgressBar }
};
</script>
<style scoped lang="scss">
P {
  margin-block-start: 0em;
  margin-block-end: 0em;
}

.box-inner {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 80px;

  img {
    margin-top: 376px;
    width: 309px;
    height: 91px;
    margin-bottom: 266px;
  }

  .title_box-inenr {
    margin-top: 32px;
    margin-bottom: 16px;
    font-size: 40px;
    font-weight: bold;
    color: #000000;
  }

  .new_title-box-inner {
    font-size: 28px;
    color: #808080;
  }
}
</style>
